// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".feedback-text[data-v-36b9899c]{padding:1em 2em 1em 2em}.feedback[data-v-36b9899c]{background-color:#f5f5f5}", ""]);
// Exports
module.exports = exports;
